import { YStack, XStack, Text, ListItem } from "tamagui";
import { colors } from "@styles/colors";
import { sampleTransaction } from "@screen/Home/sampleData";
import RadiusBoxLabel from "@components/layout/RadiusBoxLabel";
import { RiFileTextLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";

export const TransactionHistory = ({ headerShow = true }: { headerShow?: boolean }) => {
  const navigation = useNavigate();
  return (
    <YStack mt="$2" gap="$2.5">
      {headerShow && (
        <XStack jc="space-between" ai="center" px="$1">
          <Text fontWeight="bold">近期交易</Text>
          <XStack
            onPress={() => {
              navigation(`/account/wallet/transAll`);
            }}
            ai="center"
            gap="$1"
            cursor="pointer">
            <Text fontWeight="bold" color={colors.primary}>
              全部
            </Text>
          </XStack>
        </XStack>
      )}
      <YStack ov="hidden" br="$4">
        {sampleTransaction.map((item) => {
          return (
            <ListItem
              key={item.id}
              onPress={() => navigation(`/account/wallet/transDetail/${item.id}`)}
              background="#FFF"
              icon={<RadiusBoxLabel icon={<RiFileTextLine color={colors.primary} />} />}
              iconAfter={<Text fontWeight="bold">${item.amount.toLocaleString()}</Text>}
              title={
                <Text fontWeight="bold" mb={2}>
                  {item.title}
                </Text>
              }
              pressStyle={{ backgroundColor: "$gray3" }} // 加入點擊效果
              subTitle={item.date ?? ""}
              borderBottomWidth={1}
              borderBottomColor="$gray3"
            />
          );
        })}
      </YStack>
    </YStack>
  );
};

export default TransactionHistory;
